import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space2 } = theme();

  return StyleSheet.create({
    fullWidth: {
      flexGrow: 1,
    },
    pill: {
      alignSelf: "auto",
      flexGrow: 1,
    },
    separator: {
      marginRight: space2,
    },
  });
};

export { style };
